function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var $eeQ2i$reactariautils = require("@react-aria/utils");
var $eeQ2i$reactariafocus = require("@react-aria/focus");
var $eeQ2i$reactariainteractions = require("@react-aria/interactions");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "useButton", function () {
  return $988353faa005faf8$export$ea18c227d4417cc3;
});
$parcel$export(module.exports, "useToggleButton", function () {
  return $c49208f7d2aac50b$export$51e84d46ca0bc451;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */

function $988353faa005faf8$export$ea18c227d4417cc3(props, ref) {
  var _props$elementType = props.elementType,
    elementType = _props$elementType === void 0 ? "button" : _props$elementType,
    isDisabled = props.isDisabled,
    onPress = props.onPress,
    onPressStart = props.onPressStart,
    onPressEnd = props.onPressEnd,
    onPressUp = props.onPressUp,
    onPressChange = props.onPressChange,
    // @ts-ignore - undocumented
    preventFocusOnPress = props.preventFocusOnPress,
    // @ts-ignore - undocumented
    allowFocusWhenDisabled = props.allowFocusWhenDisabled,
    deprecatedOnClick = props.onClick,
    href = props.href,
    target = props.target,
    rel = props.rel,
    _props$type = props.type,
    type = _props$type === void 0 ? "button" : _props$type;
  var additionalProps;
  if (elementType === "button") additionalProps = {
    type: type,
    disabled: isDisabled
  };else additionalProps = {
    role: "button",
    tabIndex: isDisabled ? undefined : 0,
    href: elementType === "a" && isDisabled ? undefined : href,
    target: elementType === "a" ? target : undefined,
    type: elementType === "input" ? type : undefined,
    disabled: elementType === "input" ? isDisabled : undefined,
    "aria-disabled": !isDisabled || elementType === "input" ? undefined : isDisabled,
    rel: elementType === "a" ? rel : undefined
  };
  var _ref = (0, $eeQ2i$reactariainteractions.usePress)({
      onPressStart: onPressStart,
      onPressEnd: onPressEnd,
      onPressChange: onPressChange,
      onPress: onPress,
      onPressUp: onPressUp,
      isDisabled: isDisabled,
      preventFocusOnPress: preventFocusOnPress,
      ref: ref
    }),
    pressProps = _ref.pressProps,
    isPressed = _ref.isPressed;
  var _ref2 = (0, $eeQ2i$reactariafocus.useFocusable)(props, ref),
    focusableProps = _ref2.focusableProps;
  if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
  var buttonProps = (0, $eeQ2i$reactariautils.mergeProps)(focusableProps, pressProps, (0, $eeQ2i$reactariautils.filterDOMProps)(props, {
    labelable: true
  }));
  return {
    isPressed: isPressed,
    buttonProps: (0, $eeQ2i$reactariautils.mergeProps)(additionalProps, buttonProps, {
      "aria-haspopup": props["aria-haspopup"],
      "aria-expanded": props["aria-expanded"],
      "aria-controls": props["aria-controls"],
      "aria-pressed": props["aria-pressed"],
      onClick: function onClick(e) {
        if (deprecatedOnClick) {
          deprecatedOnClick(e);
          console.warn("onClick is deprecated, please use onPress");
        }
      }
    })
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $c49208f7d2aac50b$export$51e84d46ca0bc451(props, state, ref) {
  var isSelected = state.isSelected;
  var _ref3 = (0, $988353faa005faf8$export$ea18c227d4417cc3)(_objectSpread(_objectSpread({}, props), {}, {
      onPress: (0, $eeQ2i$reactariautils.chain)(state.toggle, props.onPress)
    }), ref),
    isPressed = _ref3.isPressed,
    buttonProps = _ref3.buttonProps;
  return {
    isPressed: isPressed,
    buttonProps: (0, $eeQ2i$reactariautils.mergeProps)(buttonProps, {
      "aria-pressed": isSelected
    })
  };
}